import React from 'react';
import Modal from 'react-modal';
import Row from './Row';
import { FormattedMessage, injectIntl } from 'react-intl';
import modal from '../../definitions/Modal';
import OTButton from './OTButton';
import OTButtonGroup from './OTButtonGroup';

const { id: module_id } = module;

const ConfirmationModal = (props) => {
  let {
    intl,
    hideModal,
    confirmationFunction,
    isOpen,
    moduleId = module_id,
  } = props;

  const confirmationClick = () => {
    confirmationFunction();
    hideModal();
  };
  const modalStyleOverride = modal({ content: { maxWidth: '500px' } });

  return (
    <Modal
      isOpen={isOpen}
      shouldReturnFocusAfterClose
      shouldFocusAfterRender
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onRequestClose={hideModal}
      style={modalStyleOverride}
      contentLabel={intl.formatMessage({ id: 'modal' })}
    >
      <Row>
        <h4 className={'ot-modal__title'}>
          <FormattedMessage id={`${moduleId}.confirmation.modal.title`} />
        </h4>
        <FormattedMessage
          id={`${moduleId}.confirmation.modal.content`}
          tagName={'p'}
        />
      </Row>
      <Row>
        <OTButtonGroup type={'big'} fullWidth expectedCount={2}>
          <OTButton
            message={'cancel'}
            className={'ot-button--cancel'}
            onClick={hideModal}
          />
          <OTButton message={'yes'} onClick={() => confirmationClick()} />
        </OTButtonGroup>
      </Row>
    </Modal>
  );
};

export default injectIntl(ConfirmationModal);
